module.exports = __webpack_public_path__ + "img/arrows2.791a31e3.png";